module.exports = __webpack_public_path__ + "static/assets/6dfaef3eda22fb43bf0ee4fdef218f23.svg";